<template>
    <div class="main-div">
        <div class="input-div">
            <div class="input-gift-code">
                <prime-input-text placeholder="Enter Gift Certificate Code" v-model="giftCode" class="input-giftcode" @keydown.enter="onEnter" />
                <prime-button class="btn-apply" @click="applyGiftCertificate" :loading="isLoading"> Apply </prime-button>
            </div>
            <div class="message" v-if="showMessage">
                <CheckCircleIcon v-if="isSuccess" class="check-icon" />
                <p :class="{ 'text-green-600': isSuccess, 'text-red-600': !isSuccess }">{{ message }}</p>
            </div>
        </div>
    </div>
</template>
<script setup lang="ts">
import { CheckCircleIcon } from '@heroicons/vue/24/solid';
import PrimeButton from 'primevue/button';
import PrimeInputText from 'primevue/inputtext';
import { useBillingStore } from '~/stores/person/billing';

const billingStore = useBillingStore();

const showMessage = ref(false);
const giftCode = ref('');
const isLoading = ref(false);
const isSuccess = ref(false);
const message = ref('');

const applyGiftCertificate = async () => {
    if (!giftCode.value.trim()) {
        message.value = 'Please enter a gift certificate code';
        isSuccess.value = false;
        showMessage.value = true;
        return;
    }

    isLoading.value = true;
    showMessage.value = false;

    try {
        await billingStore.applyGiftCertificate(giftCode.value);
        message.value = 'Success! Your gift certificate has been applied!';
        isSuccess.value = true;
        giftCode.value = ''; // Clear the input
        // Refresh credit balance after successful application
        await billingStore.fetchCreditBalance();
    } catch (error: any) {
        message.value = error.message || 'Failed to apply gift certificate';
        isSuccess.value = false;
    } finally {
        isLoading.value = false;
        showMessage.value = true;
    }
};

const onEnter = (e: KeyboardEvent) => {
    if (!isLoading.value) {
        applyGiftCertificate();
    }
};
</script>
<style lang="scss" scoped>
.main-div {

    .gift-code {
        @apply flex pb-6 items-center gap-1 self-stretch;

        p {
            @apply text-zinc-900 font-inter text-xl font-semibold leading-8;
        }
    }

    .input-div {
        @apply flex flex-col items-start gap-1.5 self-stretch;

        .input-gift-code {
            @apply flex rounded-sm border border-zinc-300 w-full;
        }

        .message {
            @apply flex items-center gap-2 py-1 self-stretch;

            p {
                @apply text-zinc-500 font-inter text-sm font-medium leading-5;
            }

            .check-icon {
                @apply w-5 h-5 text-green-500;
            }
        }
    }
}
.input-giftcode {
    @apply rounded-l bg-white w-full px-3 py-2 outline-none rounded-l-md;
}
.btn-apply {
    @apply rounded-r text-zinc-700 bg-white px-4 py-2 font-inter text-sm;
    @apply font-semibold leading-5 rounded-r-md;
}

.divider {
    @apply border border-zinc-300 w-full border-t my-9;
}
.inputtext-root,
.p-btn-root-primary {
    border: 0px solid var(--Zinc-300, #fff);
}
</style>
